<app-dashboard-header></app-dashboard-header>

<main>
  <div class="container">
    <h2 class="mt-5">الحلقات</h2>
    <table class="table table-bordered table-hover mt-5 mb-5">
      <thead class="thead-dark">
        <tr>
          <th>رقــم الحلقة</th>          
          <th>الصورة</th>          
          <th>العمليات</th>          
        </tr>
      </thead>

      <tbody>
        <tr style="cursor: pointer;" *ngFor="let session of sessionList" routerLink="/getSessionById/{{ session._id }}">
          <td>{{ session.sessionNumber }}</td>          
          <td class="d-flex justify-content-center align-items-center">
            <img
            class="img-fluid"
              src="{category.Image}"
              alt="تحميل الصورة"
            />
          </td>
          <td>            
              <a class="update btn btn-warning" routerLink="/updateSession/{{ session._id }}">التعديــــل</a>
              <a class="delete btn btn-dark" (click)="delete(session._id)">الحـــذف</a>                                             
          </td>                    
        </tr>
      </tbody>
    </table>
  </div>
</main>

<!-- <main>
  <div class="container">
    <div class="row">
      <div *ngFor="let session of sessionList">
        <div class="content">
          <img
            src="../../assets/images/download (2).jpg"
            alt="Denim Jeans"
            style="width: 100%"
          />
          <h1>{{ session.sessionNumber }}</h1>
          <br />
          <a
            class="btn btn-primary"
            routerLink="/getSessionById/{{ session._id }}"
            >عرض التفاصيـــل</a
          >
        </div>
      </div>
    </div>
  </div>
</main> -->

<app-dashboard-footer></app-dashboard-footer>
